import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-modal-window',
  templateUrl: './modal-window.component.html',
  styleUrls: ['./modal-window.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalWindowComponent implements OnInit, AfterViewInit {
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modal', {static: true}) modal: ElementRef;
  @ViewChild('cancel') cancel: ElementRef;

  isAfterSub = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  closeHandler(): void {
    this.closeModal.emit();
  }

  overlayClickHandler($event: MouseEvent, overlay: HTMLDivElement): void {
    if ($event.target !== overlay) {
      return;
    }
    this.closeHandler();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.modal.nativeElement.classList.add('modal-visible');
    });
  }
}
